import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { EMAIL_VALIDATION_STATUS, EMAIL_VALIDATION_STATUS_LABEL } from 'constants/contact';
import Tooltip from 'components/tooltips/Tooltip';

const styles = theme => ({
  root: {
    display: 'inline-block',
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '50%',
    boxShadow: theme.shadows[2],
  },
  valid: {
    backgroundColor: theme.palette.primary.main,
  },
  risky: {
    backgroundColor: theme.palette.accent2['1000'],
  },
  invalid: {
    backgroundColor: theme.palette.accent3['800'],
  },
  unknown: {
    border: '1px solid',
    borderColor: theme.palette.secondary['300'],
    backgroundColor: theme.palette.secondary['100'],
  },
});

const getStatusClassAndLabel = (classes, status) => {
  let label = null;
  let className = null;
  switch (status) {
    case EMAIL_VALIDATION_STATUS.VALID:
      className = classes.valid;
      label = EMAIL_VALIDATION_STATUS_LABEL.VALID;
      break;
    case EMAIL_VALIDATION_STATUS.INVALID:
      className = classes.invalid;
      label = EMAIL_VALIDATION_STATUS_LABEL.INVALID;
      break;
    case EMAIL_VALIDATION_STATUS.ACCEPT_ALL:
      className = classes.risky;
      label = EMAIL_VALIDATION_STATUS_LABEL.RISKY;
      break;
    case EMAIL_VALIDATION_STATUS.DISPOSABLE:
      className = classes.invalid;
      label = EMAIL_VALIDATION_STATUS_LABEL.INVALID;
      break;
    case EMAIL_VALIDATION_STATUS.UNKNOWN:
      className = classes.invalid;
      label = EMAIL_VALIDATION_STATUS_LABEL.INVALID;
      break;
    default:
      className = classes.unknown;
      label = EMAIL_VALIDATION_STATUS_LABEL.UNKNOWN;
      break;
  }
  return { className, label };
};

const EmailValidationStatus = (props) => {
  const { classes, status, className } = props;
  const classLabel = getStatusClassAndLabel(classes, status);
  return (
    <Tooltip
      placement="right"
      title={classLabel.label}
    >
      <div className={`${classes.root} ${classLabel.className} ${className}`} />
    </Tooltip>
  );
};

EmailValidationStatus.propTypes = {
  classes: PropTypes.element.isRequired,
  className: PropTypes.string,
  status: PropTypes.string,
};

EmailValidationStatus.defaultProps = {
  status: null,
  className: '',
};

export default withStyles(styles)(EmailValidationStatus);
